import { Dispatch, SetStateAction, useState } from "react";
import { CommentData } from "../../CommentDialog/CommentDialog";

type CommentMetadata = {
    ssqPostElementId: number;
    commentData: CommentData | null;
};

export const usePropertyComment = (): PropertyCommentState => {
    const [isCommentDialogOpen, setOpenCommentDialog] = useState<boolean>(false);
    const [commentDialogData, setCommentDialogData] = useState<CommentMetadata | null>(null);

    const setComment = (comment: CommentMetadata) => {
        setCommentDialogData(comment);
    };

    const openCommentDialog = (ssqPostElementId: number, commentData: CommentData | null) => {
        setCommentDialogData({ ssqPostElementId, commentData });
        setOpenCommentDialog(true);
    };

    const closeDialog = () => {
        setOpenCommentDialog(false);
    };

    const deleteComment = () => {
        setCommentDialogData(null);
    };

    return {
        isCommentDialogOpen,
        commentDialogData,
        openCommentDialog,
        setOpenCommentDialog,
        setComment,
        closeDialog,
        deleteComment,
    };
};

export type PropertyCommentState = {
    isCommentDialogOpen: boolean;
    commentDialogData: CommentMetadata | null;
    setComment: (comment: CommentMetadata) => void;
    openCommentDialog: (ssqPostElementId: number, commentData: CommentData | null) => void;
    setOpenCommentDialog: Dispatch<SetStateAction<boolean>>;
    closeDialog: () => void;
    deleteComment: () => void;
};
